import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import localStorage from 'local-storage';
import { api } from '../../helper/api';

const initalState = {
    address: '',
    username: '',
    bio: '',
    blockstar: '',
    twitter: '',
    profile: '',
    banner: '',
    status: 2,
    isLogin: false,
    loading: true,
    error: '',
    success: '',
    theme: 'dark'

}


export const fetchVerifySignature = createAsyncThunk('user/verifySignature', async ({ address, signature }) => {
    try {
        if (signature && address) {
            let response = await api.post('users/verifySignature', {
                address,
                signature,
            })

            if (response && response.data && response.data.error === 'OK') {
                localStorage.set('auth_token', response.data.token)
                response = await api.post('users/verifyToken', {
                    address,
                    token: response.data.token,
                })
                if (response && response.data && response.data.error === 'OK') {
                    return { isLogin: true, ...response.data.data, 'success': 'You have successfully logged in.' }
                } else {
                    localStorage.remove('auth_token')
                    return {
                        ...initalState,
                        loading: false,
                        error: response.data.error,
                    }
                }
            }
            else {
                localStorage.remove('auth_token')
                return {
                    ...initalState,
                    loading: false,
                    error: response.data.error,
                }
            }
        }
        else {
            localStorage.remove('auth_token')
            return { error: 'Invalid data found' }
        }
    }
    catch (err) {
        console.log(err.message);
    }
})


export const fetchUserInfo = createAsyncThunk('user/fetchUserInfo', async ({ address }) => {
    try {
        let token = localStorage.get('auth_token');
        if (token && token !== null && token !== 'null' && address) {
            let response = await api.post('users/verifyToken', {
                address,
                token,
            })

            if (response && response.data && response.data.error === 'OK') {
                return { isLogin: true, ...response.data.data }
            }
            else {
                localStorage.remove('auth_token')
                return {
                    ...initalState,
                    loading: false,
                }
            }
        }
        else {
            return {
                ...initalState,
                loading: false,
            }
        }
    }
    catch (err) {
        return {
            ...initalState,
            loading: false,
        }
    }
})


export const fetchUpdateProfile = createAsyncThunk('user/fetchUpdateProfile', async ({ update, address }, thunkAPI) => {
    try {
        let token = localStorage.get('auth_token');
        const currentState = thunkAPI.getState();
        
        if (token && token !== null && token !== 'null' && address && currentState) {

            let response = await api.post('users/edit', {
                address,
                token,
                profile: {
                    address: currentState.user.address,
                    username: currentState.user.username,
                    bio: currentState.user.bio,
                    blockstar: currentState.user.blockstar,
                    twitter: currentState.user.twitter,
                    profile: currentState.user.profile,
                    banner: currentState.user.banner,
                    theme: currentState.user.theme,
                    ...update
                }
            })

            if (response && response.data && response.data.error === 'OK') {
                if (response.data.token) localStorage.set('auth_token', response.data.token);
                return { ...response.data.data }
            }
            else {
                return { error: 'Update profile failed , please try again' }
            }
        }
        else {
            return { error: 'Update profile failed , please try again' }
        }
    }
    catch (err) {
        return { error: err.message }
    }
})



export const userSlice = createSlice({
    name: 'user',
    initialState: initalState,
    reducers: {
        removeToast(state) {
            state.success = '';
            state.error = '';
        },
        updateTheme(state) {
            state.theme = state.theme === 'dark' ? 'light' : 'dark';
        },
        updateField(state, action) {
            const { field, value } = action.payload;
            state[field] = value;
        },
        addLoader(state){
            state.loading = true;
        },
        removeLoader(state){
            state.loading = false;
        }
    },
    extraReducers: (builder) => {
        //fetchTokenInfo
        builder.addCase(fetchUserInfo.pending, (state) => {
            console.log('fetchUserInfo pending....');
            return { ...state, loading: true }
        })
        builder.addCase(fetchUserInfo.fulfilled, (state, action) => {
            console.log({ ...state, ...action.payload, loading: false })
            return { ...state, ...action.payload, loading: false }
        })
        builder.addCase(fetchUserInfo.rejected, (state) => {
            console.log('fetchUserInfo rejected...')
            return { ...state, loading: false }
        })

        //verifySignature
        builder.addCase(fetchVerifySignature.pending, (state) => {
            console.log('fetchVerifySignature pending....');
            return { ...state, loading: true }
        })
        builder.addCase(fetchVerifySignature.fulfilled, (state, action) => {
            return { ...state, ...action.payload, loading: false }
        })
        builder.addCase(fetchVerifySignature.rejected, (state) => {
            console.log('fetchVerifySignature rejected...')
            return { ...state, loading: false }
        })
        //fetchUpdateProfile

        builder.addCase(fetchUpdateProfile.pending, (state) => {
            console.log('fetchUpdateProfile pending....');
            return { ...state, loading: true }
        })
        builder.addCase(fetchUpdateProfile.fulfilled, (state, action) => {
            return { ...state, ...action.payload, loading: false }
        })
        builder.addCase(fetchUpdateProfile.rejected, (state) => {
            console.log('fetchUpdateProfile rejected...')
            return { ...state, loading: false }
        })
    }
})



export const { removeToast, updateTheme, updateField , addLoader , removeLoader } = userSlice.actions;
export default userSlice.reducer;